module.exports = __webpack_public_path__ + "media/36.e3b733ff.wav";